import { Util } from './../_classes/util';
import { ModalAlertaService } from './../shared/modal-alerta.service';
import { LotacaoServidor } from './../_classes/lotacao-servidor';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, take, tap } from 'rxjs/operators';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-lotacao',
  templateUrl: './lotacao.component.html',
  styleUrls: ['./lotacao.component.scss'],
})
export class LotacaoComponent implements OnInit {
  private readonly recurso: string = 'lotacao'; //mesmo que a rota
  carregando = false;
  displayedColumns: string[] = [
    'localidade.dsLocalidade',
    'numeroAto',
    'txtObservacao',
  ];

  filtro: string = '';

  erros$ = new Subject<boolean>();
  dataSource$: Observable<LotacaoServidor[]>;
  dataSource: MatTableDataSource<LotacaoServidor>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  itensAjuda = [
    {
      titulo: 'Local',
      texto:
        'Nome da localidade que se refere a lotação. Inclui também informações de subordinação, cidade/estado e instância.',
    },
    {
      titulo: 'Período',
      texto:
        'Período inicial e final da lotação naquela localidade. Juntamente com respectivo ato',
    },
    {
      titulo: 'Observações',
      texto: 'Observações genéricas da referida lotação',
    },
    {
      titulo: 'Responsável',
      texto:
        'Origem [SIGEP] - Os dados constantes desta página são meramente informativos, obtidos automaticamente do sistema',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  ngOnInit() {
    this.atualizar();
  }

  executarAoCarregarDatasource(x: LotacaoServidor[]) {
    this.dataSource = new MatTableDataSource<LotacaoServidor>(x);
    this.dataSource.filterPredicate = (data: LotacaoServidor, filter: string) =>
      data.localidade.dsLocalidade.toLowerCase().includes(filter.toLowerCase());
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;

      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.dataSource$ = this.service
      .listarLotacao(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  aplicarFiltro(event: Event) {
    this.filtro = (event.target as HTMLInputElement).value;
    this.filtrar();
  }

  filtrar() {
    //console.log(this.filtro);

    this.dataSource.filter = this.filtro.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
